<template>
    <SoliForm
        :title="relationship ? 'Edit Relationship' : 'Add Relationship'"
        text="Save"
        icon="save"
        ref="form"
        :loadingProp="form.processing"
        @reset="$emit('reset')"
        @submit="relationship ? editRelationship() : addRelationship()"
    >
        <template #body>
            <v-switch
                v-if="
                    can('Create students') &&
                    $page.props.staffView &&
                    !relationship
                "
                v-model="addNewClient"
                @change="
                    [
                        (form.first_name = null),
                        (form.last_name = null),
                        (form.email = null),
                        (form.existingUser = null),
                    ]
                "
                label="Add New Client"
                class="px-2 mt-0"
                dense
            ></v-switch>
            <SoliStudents
                v-if="
                    can('Link existing clients') &&
                    $page.props.staffView &&
                    !relationship &&
                    !addNewClient
                "
                v-model="form.existingUser"
                label="Existing Clients"
                @input="selectExistingUser"
                autocomplete
                onDemand
                :user="user"
                :filter="relationships.map((e) => e.name)"
            ></SoliStudents>
            <v-row v-if="!relationship && addNewClient">
                <v-col>
                    <v-text-field
                        v-model="form.first_name"
                        prepend-inner-icon="person"
                        label="First Name"
                        outlined
                        :rules="rules.input"
                        dense
                    ></v-text-field
                ></v-col>
                <v-col>
                    <v-text-field
                        v-model="form.last_name"
                        label="Last Name"
                        outlined
                        :rules="rules.input"
                        dense
                    ></v-text-field
                ></v-col>
            </v-row>
            <v-select
                :items="relationshipOptions"
                :item-text="getRelation"
                label="Relationship"
                return-object
                v-model="form.relation"
                outlined
                dense
                :rules="rules.select"
                prepend-inner-icon="handshake"
            >
            </v-select>
            <v-text-field
                v-if="!relationship && form.loginable"
                v-model="form.email"
                label="Email"
                outlined
                prepend-inner-icon="alternate_email"
                validate-on-blur
                :rules="rules.email"
                dense
            ></v-text-field>
            <v-switch
                v-if="!relationship && addNewClient"
                v-model="form.loginable"
                label="Give login"
                class="px-2 mt-0"
                dense
            ></v-switch>
        </template>
    </SoliForm>
</template>

<script>
import SoliForm from "./../Base/SoliForm";

export default {
    props: {
        user: {},
        relationship: { type: Object, default: null },
        relationships: {},
    },
    data() {
        return {
            form: this.$inertia.form({
                first_name: null,
                last_name: null,
                email: null,
                loginable: false,
                relation: this.relationship ? this.relationship.pivot : null,
                existingUser: null,
                email_updates:
                    this.relationship && this.user.email
                        ? this.relationship.pivot.email_updates
                        : true,
            }),
            addNewClient: true,
            rules: SoliForm.formRules,
            formOptions: {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$refs.form.reset();
                    this.$emit("success");
                },
                onFailure: (errors) => {
                    console.log(
                        "This form returned errors:" + JSON.stringify(errors)
                    );
                },
            },
            relationshipOptions: [
                {
                    inverse: "Parent",
                    relation: "Child",
                },
                {
                    inverse: "Child",
                    relation: "Parent",
                },
                {
                    inverse: "Grandchild",
                    relation: "Grandparent",
                },
                {
                    inverse: "Grandparent",
                    relation: "Grandchild",
                },
                {
                    inverse: "Sibling",
                    relation: "Sibling",
                },
                {
                    inverse: "Friend",
                    relation: "Friend",
                },
                {
                    inverse: "Spouse",
                    relation: "Spouse",
                },
                {
                    inverse: "Other",
                    relation: "Other",
                },
            ],
        };
    },
    methods: {
        selectExistingUser(user) {
            if (!user) return;
            this.form.first_name = user.first_name;
            this.form.last_name = user.last_name;
            this.form.email = user.email;
            this.form.loginable = null;
        },
        editRelationship() {
            this.form
                .transform((data) => ({
                    ...data,
                    locations: null,
                    user_id: null,
                    parent_id: null,
                    relation: this.form.relation.relation,
                    inverse: this.form.relation.inverse,
                    email_updates: this.form.email_updates,
                }))
                .put(
                    route("relationUsers.update", this.relationship.pivot.id),
                    this.formOptions
                );
        },
        addRelationship() {
            this.form
                .transform((data) => ({
                    ...data,
                    locations: this.user.locations.map((l) => l.id),
                    user_id: this.form.existingUser
                        ? this.form.existingUser.id
                        : null,
                    parent_id: this.user.id,
                    relation: this.form.relation.inverse,
                    inverse: this.form.relation.relation,
                }))
                .post(route("relationUsers.store"), this.formOptions);
        },
    },
    computed: {
        getRelation() {
            if (!this.relationship) return "relation";
            return this.relationship.pivot.user_id == this.user.id
                ? "inverse"
                : "relation";
        },
    },
};
</script>
